import React from "react";
import ReactApexChart from "react-apexcharts";

// Imported Styles
import "./scorecardStyles.css";

const StatsChart = () => {
  const chart = {
    series: [
      {
        name: "Player",
        data: [80, 50, 30, 40, 100],
        color: "#FF007E",
      },
      {
        name: "Yeti",
        data: [20, 30, 40, 80, 20],
        color: "#A853FE",
      },
    ],
    options: {
      chart: {
        type: "radar",
        dropShadow: {
          enabled: true,
          blur: 1,
          left: 1,
          top: 1,
        },
        toolbar: {
          show: false,
        }
      },
      stroke: {
        width: 2,
      },
      fill: {
        opacity: 0.1,
      },
      markers: {
        size: 0,
      },
      xaxis: {
        categories: ["Revenue", "Upsells", "MX Plan", "Reviews", "Callback"],
      },
    },
  };

  return (
    <div className="overflow-hidden">
      <ReactApexChart
        options={chart.options}
        series={chart.series}
        type="radar"
      />
    </div>
  );
};

export default StatsChart;
